import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GeneralService } from "../services/general.service";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  constructor(private router: Router, private generalService: GeneralService) {
    this.generalService.showMenu = false;
  }
  passwordUser;
  nameUser;
  showAlert = false;
  disabledBtnConnection: boolean = false;
  exist: boolean = true;
  errorMessage: string = "";
  //showMenu =

  ngOnInit() {
    this.generalService.getDsLanguage();
    this.generalService.getDsFile();
  }
  connection() {
    this.disabledBtnConnection = true;
    this.exist = false;
    this.errorMessage = "";
    this.generalService
      .rechercheTable(
        this.generalService.urlConnectionClient +
          this.nameUser +
          "&pw=" +
          this.passwordUser
      )
      .subscribe((user: any) => {
        if (user.code == "ok") {
          this.generalService.showMenu = true;
          this.generalService.userLogin = true;
          this.router.navigate(["admin/index"]);
          this.generalService.userConnecter = this.nameUser;
          localStorage.setItem("login", "true");
        } else {
          localStorage.setItem("login", "false");
          this.generalService.userLogin = false;
          this.exist = true;
          this.disabledBtnConnection = false;
          this.errorMessage = "Mot de passe ou / et utilisateur incorrect";
        }
      });
  }
  // dsLogin;
  // connection() {
  //   this.disabledBtnConnection = true;
  //   this.exist = false;
  //   this.errorMessage = "";
  //   this.dsLogin = {
  //     username: this.nameUser,
  //     password: this.passwordUser,
  //   };
  //   this.generalService.loginUniges(this.dsLogin).subscribe((user: any) => {
  //     if (user.accessToken) {
  //       this.generalService.showMenu = true;
  //       this.generalService.userLogin = true;
  //       this.router.navigate(["admin/index"]);
  //       this.generalService.userConnecter = this.nameUser;
  //       localStorage.setItem("login", "true");
  //     } else {
  //       localStorage.setItem("login", "false");
  //       this.generalService.userLogin = false;
  //       this.exist = true;
  //       this.disabledBtnConnection = false;
  //       this.errorMessage = "Mot de passe ou / et utilisateur incorrect";
  //     }
  //   });
  // }
}
